/**
 * Attempt to visually discourage double-clicking form buttons by changing it to
 * a loading icon on click. In addition, track clicks when
 */
(function _FormDoubleClickDiscourager() {
  const _forms_in_flight = {};

  /**
   * Add a loading indicator to a button, and track an event if that form is
   * submitted again before the previous request has finished.
   * @param {String} form_name
   * @param {Element} button
   * @param {$.Deferred} promise
   */
  window.merchantos.sidebar.xhrStarted = function xhrStarted(form_name, button, promise) {
    const has_mod = window.lsCloud.Modules.hasModule('ui.forms.discourage_dblclick');

    // Only B group gets indicator
    _addIndicator(form_name, button, promise, has_mod);
  };

  /**
   * Given a button and a promise, it will apply the "_loading" class onto the
   * element until promise is either resolved or failed.
   * @param {String} form_name
   * @param {Element} button
   * @param {$.Deferred} promise
   * @param {boolean} has_mod
   */
  function _addIndicator(form_name: TSFixMe, button: TSFixMe, promise: TSFixMe, has_mod: TSFixMe) {
    let _state = 0; // 1 = timeout ran, 2 = promise ran

    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!_forms_in_flight[form_name]) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      _forms_in_flight[form_name] = 1;
    } else {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      _forms_in_flight[form_name]++;
    }

    if (has_mod) {
      // Avoid quick flashes of loading for short requests by delaying 100ms
      setTimeout(() => {
        if (_state === 0) {
          _state = 1;
          button.className += ' _loading';
        }
      }, 100);
    }

    // Remove loading state once the promise completes
    promise.always(() => {
      if (has_mod && _state === 1) {
        button.className = button.className.replace('_loading', '');
      }
      _state = 2; // promise finished
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      _forms_in_flight[form_name]--;
    });
  }
})();
